/**
 * ES5 无法直接继承 Map 对象，通过一个 ProxyMap 代理过去
 * @public
 */
class ProxyMap {
    constructor() {
        this.map = new Map();
    }
    get(key) {
        return this.map.get(key);
    }
    has(key) {
        return this.map.has(key);
    }
    set(key, metadata) {
        this.map.set(key, metadata);
        return this;
    }
    delete(key) {
        return this.map.delete(key);
    }
    forEach(fn, _thisArg) {
        return this.map.forEach(fn);
    }
    keys() {
        return this.map.keys();
    }
    values() {
        return this.map.values();
    }
    entries() {
        return this.map.entries();
    }
    clear() {
        return this.map.clear();
    }
    get size() {
        return this.map.size;
    }
}

export { ProxyMap };
//# sourceMappingURL=proxy-map.js.map
